<template>
  <b-dropdown
    v-if="enabled && ready"
    class="menu-item"
    right
    variant="link"
    :disabled="switching"
    toggle-class="menu-link border-0 px-3"
    menu-class="dropdown-menu"
  >
    <template v-slot:button-content>
      <span class="font-weight-semibold">{{ activeMarket ? activeMarket.name : 'Market' }}</span>
      <span v-if="activeMarket" class="text-muted ml-2">{{ activeMarket.default_currency }}</span>
    </template>

    <b-dropdown-item
      v-for="market in markets"
      :key="market.code"
      :active="market.code === activeCode"
      @click="selectMarket(market.code)"
    >
      <span class="d-flex align-items-center justify-content-between">
        <span>{{ market.name }} <span class="text-muted ml-2">{{ market.default_currency }}</span></span>
        <i v-if="market.code === activeCode" class="fa fa-check ml-3" />
      </span>
      <small class="d-block text-muted">Allowed currencies: {{ market.allowed_currencies.join(', ') }}</small>
      <small class="d-block text-muted">Loyalty: {{ market.loyalty_enabled ? 'enabled' : 'unavailable' }}</small>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { safeMarketSwitchUrl, shouldWarnBeforeMarketSwitch } from '@/market'

export default {
  name: 'MarketSelector',

  data() {
    return {
      switching: false,
    }
  },

  computed: {
    ...mapGetters('market', [
      'enabled',
      'markets',
      'activeCode',
      'activeMarket',
      'ready',
    ]),
  },

  methods: {
    async selectMarket(code) {
      if (this.switching || code === this.activeCode) {
        return
      }

      if (
        shouldWarnBeforeMarketSwitch(this.$route.path)
        && !window.confirm('Switching markets will leave this page and discard any unsaved changes. Continue?')
      ) {
        return
      }

      this.switching = true
      try {
        const selected = await this.$store.dispatch('market/select', code)
        if (selected) {
          window.location.assign(safeMarketSwitchUrl(this.$route.path))
        } else {
          this.switching = false
        }
      } catch (error) {
        this.switching = false
        throw error
      }
    },
  },
}
</script>
